<script setup>
const nuxtApp = useNuxtApp()
const props = defineProps({
    id: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `${props.handle}-audios`,
    () => $fetch(`/api/product/query?id=${props.id}&what=audios`),
    {
        transform: (data) => {
            return {
                audios: data.product.productAudio.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

if (error.value) {
    throw createError({
        statusCode: 500,
        message: error.value,
        //fatal: true,
    })
}
</script>

<template>
    <v-row id="productaudios" class="justify-center">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="12"><app-loader /></v-col>
        <v-col v-else-if="data.audios && data.audios.length > 0" cols="12" class="mb-8 rounded">
            <v-row justify="center">
                <!-- <v-col cols="12" class="mb-4 text-center">
                    <app-section-header :id="`audio`" :title="`Audio`" :subtitle="`Audio demos`" />
                </v-col> -->
                <v-col v-for="audio in data.audios" :key="audio.id" cols="12" sm="6" md="4" lg="3">
                    <v-card v-if="audio" variant="flat" class="bg-transparent">
                        <iframe
                            width="100%"
                            scrolling="no"
                            frameborder="no"
                            :src="
                                `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/` +
                                audio.source +
                                `&color=%23DD2C00&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=false&visual=false`
                            "
                        ></iframe>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
